import { Typography } from "@suraasa/placebo-ui"
import { CpatAttemptStatus } from "api/resources/cpat/types"
import EmptyStateImage from "assets/Cpat/cpat_report_empty_state.webp"
import { LoadingReportBanner } from "features/Cpat/Banners/CpatReportLoadingBanner"
import CpatReportReadyBanner from "features/Cpat/Banners/CpatReportReadyBanner"
import { useCpat } from "features/Cpat/useCpat"
import isNil from "lodash/isNil"

import { AssessmentCompletedWithoutReport } from "../CpatAssessmentCompletedWithoutReport"
import CpatDisqualifiedBanner from "../CpatDisqualifiedBanner"

const CpatResultBanner = () => {
  const { attempt, reports } = useCpat()

  if (!attempt || isNil(attempt.data)) {
    return null
  }

  const isCompleted = attempt.data?.status === CpatAttemptStatus.COMPLETED

  const reportVisibilityAllowed =
    attempt.data?.assessment.reportVisibility === "visible_to_all"

  const isReportReady = reports.data?.some(
    report => String(report.referenceId) === String(attempt.data?.id)
  )

  const isReportLoading = isCompleted && !isReportReady

  const isDisqualified = attempt.data?.status === CpatAttemptStatus.DISQUALIFIED

  if (isDisqualified) {
    return (
      <CpatDisqualifiedBanner
        attemptId={attempt.data.id}
        date={attempt.data.startTime}
      />
    )
  }

  if (isReportReady) {
    return <CpatReportReadyBanner />
  }

  if (!reportVisibilityAllowed && isCompleted) {
    return <AssessmentCompletedWithoutReport />
  }

  if (reportVisibilityAllowed && isReportLoading) {
    return <LoadingReportBanner />
  }

  if (reports.data?.length === 0) {
    return (
      <div className="mb-8 mt-6 flex flex-wrap items-center justify-center md:my-12">
        <img src={EmptyStateImage} alt="" className="h-[174px]" />
        <div className="flex flex-col text-center md:text-left">
          <Typography variant="title3" className="mb-0.5 text-onSurface-600">
            Nothing to see here yet!
          </Typography>
          <Typography variant="smallBody" className="text-onSurface-500">
            Your final report will appear here once you take the assessment
          </Typography>
        </div>
      </div>
    )
  }
  return null
}

export default CpatResultBanner
